module.exports = __webpack_public_path__ + "static/media/no.61c940d4.svg";